/**
 * 购买更多折扣表：复制优惠码（.js-buyMoreCodeContainer + .buy-more-copy-btn）
 */
(function () {
  var TOOLTIP_MS = 2200;
  var timers = new WeakMap();

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () {
          return true;
        },
        function () {
          return false;
        }
      );
    }
    return new Promise(function (resolve) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        resolve(ok);
      } catch (e) {
        resolve(false);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var btn = target.closest('.buy-more-copy-btn');
    if (!btn || btn.tagName !== 'BUTTON') return;

    var container = btn.closest('.js-buyMoreCodeContainer');
    if (!container) return;

    event.preventDefault();

    var code = btn.getAttribute('data-code');
    if (!code) return;

    Promise.resolve(copyText(code)).then(function (ok) {
      var tooltip = btn.querySelector('.buy-more-tooltip');
      var copyLabel = btn.getAttribute('data-copy-label') || 'Copy';
      var copiedLabel = btn.getAttribute('data-copied-label') || 'Copied!';
      var failLabel = btn.getAttribute('data-copy-failed-label') || 'Copy failed';

      if (tooltip) {
        tooltip.textContent = ok ? copiedLabel : failLabel;
      }

      btn.classList.add('buy-more-copy-btn--tooltip-visible');

      var prev = timers.get(btn);
      if (prev !== undefined) clearTimeout(prev);

      var timerId = setTimeout(function () {
        btn.classList.remove('buy-more-copy-btn--tooltip-visible');
        if (tooltip) tooltip.textContent = copyLabel;
        timers.delete(btn);
      }, TOOLTIP_MS);

      timers.set(btn, timerId);
    });
  });
})();
